import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react"
import { ITurnoEdit } from "../../../../Interfaces/auxiliar/ITurno"
import { UseTurno } from "./useTurno"
import themeBase from "../../../../utils/theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelTurnoInsertar } from "./TurnoInsertar/PanelTurnoInsertar"
import { PanelTurnoEditar } from "./TurnoEditar/PanelTurnoEditar"
import { useState } from "react"
import { PanelTurnoEliminar } from "./TurnoEliminar/PanelTurnoEliminar"
import { PanelTurnoFiltro } from "./TurnoFiltro/PanelTurnoFiltro"
import { CabeceraTable } from "../../../../components/Table/CabeceraTable"
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent"
import IconHelper from "../../../../utils/helpers/iconHelper"


export const Turno = () => {
  const iconDetalleStyle: React.CSSProperties | undefined = {
    cursor: "pointer",
    color: "#0078d4",
  };
  const [isOpenTurno, { setTrue: openPanelTurno, setFalse: closePanelTurno }] = useBoolean(false);
  const [isOpenFiltrar, { setTrue: openPanelFiltrar, setFalse: closePanelFiltrar }] = useBoolean(false);
  const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
  const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
  const { items, filter, setFilter, loading, pagination, onChangeSearch, getTurnos, handleResetUpdate, onChangeTake, _onkeyUpSearchTable } = UseTurno()
  const [item, setItem] = useState<ITurnoEdit>({
    nombre: "",
    codigo: "",
    horaInicio: "",
    horaFin: "", turnoId: ""
  })

  const buttonLeft: ICommandBarItemProps[] = [
    // {
    //   ...IconHelper.ICON_ADD_TABLE,
    //   text: "Nuevo",
    //   onClick: () => {
    //     openPanelTurno()
    //   },
    // },
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        handleResetUpdate()
      },
    }
  ];
  const buttonRight: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BS_FILTER,
      text: "Filtrar",
      onClick: () => {
        openPanelFiltrar()
      },
    }
  ];

  function renderOpciones(item: ITurnoEdit) {
    return (
      <>
        <TooltipHost content={"Editar"}>
          <Icon
            iconName="Edit"
            className={themeBase.classNamesIcon.iconFont}
            style={{ cursor: "pointer", color: "#0078d3" }}
            onClick={() => {
              setItem(item)
              openPanelEditar()
            }}
          />
        </TooltipHost>
        <TooltipHost content={"Quitar"}>
          <Icon
            iconName="Delete"
            className={themeBase.classNamesIcon.iconFont}
            style={{ cursor: "pointer", color: "#0078d3" }}
            onClick={() => {
              setItem(item)
              openPanelEliminar()
            }}
          />
        </TooltipHost>
      </>
    );
  }
  const _columns = [
    {
      key: "turno",
      name: "Turno",
      fieldName: "nombre",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "codigo",
      name: "Codigo",
      fieldName: "codigo",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "horaInicio",
      name: "Hora Inicio",
      fieldName: "horaInicio",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "horaFin",
      name: "Hora Fin",
      fieldName: "horaFin",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 100,
      maxWidth: 300,
      onRender: (item: any) => renderOpciones(item)
    }
  ]

  return (
    <>
      <CabeceraTable
        Titulo={"Turno"}
        SubTitulo={"Gestión de Turnos"}
        // placeholder="buscar..."
        // // componentRef={onChangeSearch}
        onKeyUp={_onkeyUpSearchTable}
      />
      <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
      />
      <PanelTurnoInsertar
        isOpen={isOpenTurno}
        onDismiss={closePanelTurno}
        reload={handleResetUpdate} />
      <PanelTurnoFiltro
        isOpen={isOpenFiltrar}
        onDismiss={closePanelFiltrar}
        filtro={filter}
        setFiltro={setFilter}
        reload={getTurnos}
      />
      <PanelTurnoEditar
        item={item}
        isOpen={isOpenEditar}
        onDismiss={closePanelEditar}
        reload={handleResetUpdate} />

      {isOpenEliminar && <PanelTurnoEliminar
        item={item}
        isOpen={isOpenEliminar}
        onDismiss={closePanelEliminar}
        reload={handleResetUpdate}
      />
      }
    </>
  )
}